var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0582,
    cy: 25,
    rx: 25.0582,
    ry: 25,
    fill: "#F39C12",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0906 20.5904C38.0906 20.9836 37.8873 21.4704 37.2757 22.0266C36.6638 22.583 35.7226 23.13 34.4748 23.61C31.9858 24.5674 28.4796 25.1807 24.5569 25.1807C20.6342 25.1807 17.128 24.5674 14.639 23.61C13.3912 23.13 12.45 22.583 11.8381 22.0266C11.2265 21.4704 11.0232 20.9836 11.0232 20.5904C11.0232 20.1971 11.2265 19.7104 11.8381 19.1542C12.45 18.5977 13.3912 18.0507 14.639 17.5707C17.128 16.6133 20.6342 16 24.5569 16C28.4796 16 31.9858 16.6133 34.4748 17.5707C35.7226 18.0507 36.6638 18.5977 37.2757 19.1542C37.8873 19.7104 38.0906 20.1971 38.0906 20.5904Z",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8089 20.4865V30.2837C10.8089 32.927 16.7237 34.9156 24.557 34.9156C32.3904 34.9156 38.3052 32.927 38.3052 30.2837V20.4865",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5225 24.0135V34.2027",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8076 25.1892L21.8076 34.5946",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0922 25.1892L28.0922 34.5946",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.592 24.0135V34.2027",
    stroke: "#F39C12",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding);
export default __webpack_public_path__ + "static/media/funding.33208c1e35028fd2fcb993846189bbf7.svg";
export { ForwardRef as ReactComponent };